import { render, staticRenderFns } from "./sbScreenToysPanel.vue?vue&type=template&id=3790e5e8&scoped=true"
import script from "./sbScreenToysPanel.vue?vue&type=script&lang=ts"
export * from "./sbScreenToysPanel.vue?vue&type=script&lang=ts"
import style0 from "./sbScreenToysPanel.vue?vue&type=style&index=0&id=3790e5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3790e5e8",
  null
  
)

export default component.exports